export const Industry_code_dict =
{
"010":"農業，林業",
"011":"農業，林業",
"012":"農業，林業",
"013":"農業，林業",
"014":"農業，林業",
"020":"農業，林業",
"021":"農業，林業",
"022":"農業，林業",
"023":"農業，林業",
"024":"農業，林業",
"029":"農業，林業",
"030":"漁業",
"031":"漁業",
"032":"漁業",
"040":"漁業",
"041":"漁業",
"042":"漁業",
"050":"鉱業，採石業，砂利採取業",
"051":"鉱業，採石業，砂利採取業",
"052":"鉱業，採石業，砂利採取業",
"053":"鉱業，採石業，砂利採取業",
"054":"鉱業，採石業，砂利採取業",
"055":"鉱業，採石業，砂利採取業",
"059":"鉱業，採石業，砂利採取業",
"060":"建設業",
"061":"建設業",
"062":"建設業",
"063":"建設業",
"064":"建設業",
"065":"建設業",
"066":"建設業",
"070":"建設業",
"071":"建設業",
"072":"建設業",
"073":"建設業",
"074":"建設業",
"075":"建設業",
"076":"建設業",
"077":"建設業",
"078":"建設業",
"079":"建設業",
"080":"建設業",
"081":"建設業",
"082":"建設業",
"083":"建設業",
"084":"建設業",
"089":"建設業",
"090":"製造業",
"091":"製造業",
"092":"製造業",
"093":"製造業",
"094":"製造業",
"095":"製造業",
"096":"製造業",
"097":"製造業",
"098":"製造業",
"099":"製造業",
"100":"製造業",
"101":"製造業",
"102":"製造業",
"103":"製造業",
"104":"製造業",
"105":"製造業",
"106":"製造業",
"110":"製造業",
"111":"製造業",
"112":"製造業",
"113":"製造業",
"114":"製造業",
"115":"製造業",
"116":"製造業",
"117":"製造業",
"118":"製造業",
"119":"製造業",
"120":"製造業",
"121":"製造業",
"122":"製造業",
"123":"製造業",
"129":"製造業",
"130":"製造業",
"131":"製造業",
"132":"製造業",
"133":"製造業",
"139":"製造業",
"140":"製造業",
"141":"製造業",
"142":"製造業",
"143":"製造業",
"144":"製造業",
"145":"製造業",
"149":"製造業",
"150":"製造業",
"151":"製造業",
"152":"製造業",
"153":"製造業",
"159":"製造業",
"160":"製造業",
"161":"製造業",
"162":"製造業",
"163":"製造業",
"164":"製造業",
"165":"製造業",
"166":"製造業",
"169":"製造業",
"170":"製造業",
"171":"製造業",
"172":"製造業",
"173":"製造業",
"174":"製造業",
"179":"製造業",
"180":"製造業",
"181":"製造業",
"182":"製造業",
"183":"製造業",
"184":"製造業",
"185":"製造業",
"189":"製造業",
"190":"製造業",
"191":"製造業",
"192":"製造業",
"193":"製造業",
"199":"製造業",
"200":"製造業",
"201":"製造業",
"202":"製造業",
"203":"製造業",
"204":"製造業",
"205":"製造業",
"206":"製造業",
"207":"製造業",
"208":"製造業",
"209":"製造業",
"210":"製造業",
"211":"製造業",
"212":"製造業",
"213":"製造業",
"214":"製造業",
"215":"製造業",
"216":"製造業",
"217":"製造業",
"218":"製造業",
"219":"製造業",
"220":"製造業",
"221":"製造業",
"222":"製造業",
"223":"製造業",
"224":"製造業",
"225":"製造業",
"229":"製造業",
"230":"製造業",
"231":"製造業",
"232":"製造業",
"233":"製造業",
"234":"製造業",
"235":"製造業",
"239":"製造業",
"240":"製造業",
"241":"製造業",
"242":"製造業",
"243":"製造業",
"244":"製造業",
"245":"製造業",
"246":"製造業",
"247":"製造業",
"248":"製造業",
"249":"製造業",
"250":"製造業",
"251":"製造業",
"252":"製造業",
"253":"製造業",
"259":"製造業",
"260":"製造業",
"261":"製造業",
"262":"製造業",
"263":"製造業",
"264":"製造業",
"265":"製造業",
"266":"製造業",
"267":"製造業",
"269":"製造業",
"270":"製造業",
"271":"製造業",
"272":"製造業",
"273":"製造業",
"274":"製造業",
"275":"製造業",
"276":"製造業",
"280":"製造業",
"281":"製造業",
"282":"製造業",
"283":"製造業",
"284":"製造業",
"285":"製造業",
"289":"製造業",
"290":"製造業",
"291":"製造業",
"292":"製造業",
"293":"製造業",
"294":"製造業",
"295":"製造業",
"296":"製造業",
"297":"製造業",
"299":"製造業",
"300":"製造業",
"301":"製造業",
"302":"製造業",
"303":"製造業",
"310":"製造業",
"311":"製造業",
"312":"製造業",
"313":"製造業",
"314":"製造業",
"315":"製造業",
"319":"製造業",
"320":"製造業",
"321":"製造業",
"322":"製造業",
"323":"製造業",
"324":"製造業",
"325":"製造業",
"326":"製造業",
"327":"製造業",
"328":"製造業",
"329":"製造業",
"330":"電気・ガス・熱供給・水道業",
"331":"電気・ガス・熱供給・水道業",
"340":"電気・ガス・熱供給・水道業",
"341":"電気・ガス・熱供給・水道業",
"350":"電気・ガス・熱供給・水道業",
"351":"電気・ガス・熱供給・水道業",
"360":"電気・ガス・熱供給・水道業",
"361":"電気・ガス・熱供給・水道業",
"362":"電気・ガス・熱供給・水道業",
"363":"電気・ガス・熱供給・水道業",
"370":"情報通信業",
"371":"情報通信業",
"372":"情報通信業",
"373":"情報通信業",
"380":"情報通信業",
"381":"情報通信業",
"382":"情報通信業",
"383":"情報通信業",
"390":"情報通信業",
"391":"情報通信業",
"392":"情報通信業",
"400":"情報通信業",
"401":"情報通信業",
"410":"情報通信業",
"411":"情報通信業",
"412":"情報通信業",
"413":"情報通信業",
"414":"情報通信業",
"415":"情報通信業",
"416":"情報通信業",
"420":"運輸業，郵便業",
"421":"運輸業，郵便業",
"430":"運輸業，郵便業",
"431":"運輸業，郵便業",
"432":"運輸業，郵便業",
"433":"運輸業，郵便業",
"439":"運輸業，郵便業",
"440":"運輸業，郵便業",
"441":"運輸業，郵便業",
"442":"運輸業，郵便業",
"443":"運輸業，郵便業",
"444":"運輸業，郵便業",
"449":"運輸業，郵便業",
"450":"運輸業，郵便業",
"451":"運輸業，郵便業",
"452":"運輸業，郵便業",
"453":"運輸業，郵便業",
"454":"運輸業，郵便業",
"460":"運輸業，郵便業",
"461":"運輸業，郵便業",
"462":"運輸業，郵便業",
"470":"運輸業，郵便業",
"471":"運輸業，郵便業",
"472":"運輸業，郵便業",
"480":"運輸業，郵便業",
"481":"運輸業，郵便業",
"482":"運輸業，郵便業",
"483":"運輸業，郵便業",
"484":"運輸業，郵便業",
"485":"運輸業，郵便業",
"489":"運輸業，郵便業",
"490":"運輸業，郵便業",
"491":"運輸業，郵便業",
"500":"卸売業・小売業",
"501":"卸売業・小売業",
"510":"卸売業・小売業",
"511":"卸売業・小売業",
"512":"卸売業・小売業",
"513":"卸売業・小売業",
"520":"卸売業・小売業",
"521":"卸売業・小売業",
"522":"卸売業・小売業",
"530":"卸売業・小売業",
"531":"卸売業・小売業",
"532":"卸売業・小売業",
"533":"卸売業・小売業",
"534":"卸売業・小売業",
"535":"卸売業・小売業",
"536":"卸売業・小売業",
"540":"卸売業・小売業",
"541":"卸売業・小売業",
"542":"卸売業・小売業",
"543":"卸売業・小売業",
"549":"卸売業・小売業",
"550":"卸売業・小売業",
"551":"卸売業・小売業",
"552":"卸売業・小売業",
"553":"卸売業・小売業",
"559":"卸売業・小売業",
"560":"卸売業・小売業",
"561":"卸売業・小売業",
"569":"卸売業・小売業",
"570":"卸売業・小売業",
"571":"卸売業・小売業",
"572":"卸売業・小売業",
"573":"卸売業・小売業",
"574":"卸売業・小売業",
"579":"卸売業・小売業",
"580":"卸売業・小売業",
"581":"卸売業・小売業",
"582":"卸売業・小売業",
"583":"卸売業・小売業",
"584":"卸売業・小売業",
"585":"卸売業・小売業",
"586":"卸売業・小売業",
"589":"卸売業・小売業",
"590":"卸売業・小売業",
"591":"卸売業・小売業",
"592":"卸売業・小売業",
"593":"卸売業・小売業",
"600":"卸売業・小売業",
"601":"卸売業・小売業",
"602":"卸売業・小売業",
"603":"卸売業・小売業",
"604":"卸売業・小売業",
"605":"卸売業・小売業",
"606":"卸売業・小売業",
"607":"卸売業・小売業",
"608":"卸売業・小売業",
"609":"卸売業・小売業",
"610":"卸売業・小売業",
"611":"卸売業・小売業",
"612":"卸売業・小売業",
"619":"卸売業・小売業",
"620":"金融業・保険業",
"621":"金融業・保険業",
"622":"金融業・保険業",
"630":"金融業・保険業",
"631":"金融業・保険業",
"632":"金融業・保険業",
"640":"金融業・保険業",
"641":"金融業・保険業",
"642":"金融業・保険業",
"643":"金融業・保険業",
"649":"金融業・保険業",
"650":"金融業・保険業",
"651":"金融業・保険業",
"652":"金融業・保険業",
"660":"金融業・保険業",
"661":"金融業・保険業",
"662":"金融業・保険業",
"663":"金融業・保険業",
"670":"金融業・保険業",
"671":"金融業・保険業",
"672":"金融業・保険業",
"673":"金融業・保険業",
"674":"金融業・保険業",
"675":"金融業・保険業",
"680":"不動産業，物品賃貸業",
"681":"不動産業，物品賃貸業",
"682":"不動産業，物品賃貸業",
"690":"不動産業，物品賃貸業",
"691":"不動産業，物品賃貸業",
"692":"不動産業，物品賃貸業",
"693":"不動産業，物品賃貸業",
"694":"不動産業，物品賃貸業",
"700":"不動産業，物品賃貸業",
"701":"不動産業，物品賃貸業",
"702":"不動産業，物品賃貸業",
"703":"不動産業，物品賃貸業",
"704":"不動産業，物品賃貸業",
"705":"不動産業，物品賃貸業",
"709":"不動産業，物品賃貸業",
"710":"学術研究，専門・技術サービス業",
"711":"学術研究，専門・技術サービス業",
"712":"学術研究，専門・技術サービス業",
"720":"学術研究，専門・技術サービス業",
"721":"学術研究，専門・技術サービス業",
"722":"学術研究，専門・技術サービス業",
"723":"学術研究，専門・技術サービス業",
"724":"学術研究，専門・技術サービス業",
"725":"学術研究，専門・技術サービス業",
"726":"学術研究，専門・技術サービス業",
"727":"学術研究，専門・技術サービス業",
"728":"学術研究，専門・技術サービス業",
"729":"学術研究，専門・技術サービス業",
"730":"学術研究，専門・技術サービス業",
"731":"学術研究，専門・技術サービス業",
"740":"学術研究，専門・技術サービス業",
"741":"学術研究，専門・技術サービス業",
"742":"学術研究，専門・技術サービス業",
"743":"学術研究，専門・技術サービス業",
"744":"学術研究，専門・技術サービス業",
"745":"学術研究，専門・技術サービス業",
"746":"学術研究，専門・技術サービス業",
"749":"学術研究，専門・技術サービス業",
"750":"宿泊業，飲食サービス業",
"751":"宿泊業，飲食サービス業",
"752":"宿泊業，飲食サービス業",
"753":"宿泊業，飲食サービス業",
"759":"宿泊業，飲食サービス業",
"760":"宿泊業，飲食サービス業",
"761":"宿泊業，飲食サービス業",
"762":"宿泊業，飲食サービス業",
"763":"宿泊業，飲食サービス業",
"764":"宿泊業，飲食サービス業",
"765":"宿泊業，飲食サービス業",
"766":"宿泊業，飲食サービス業",
"767":"宿泊業，飲食サービス業",
"769":"宿泊業，飲食サービス業",
"770":"宿泊業，飲食サービス業",
"771":"宿泊業，飲食サービス業",
"772":"宿泊業，飲食サービス業",
"780":"生活関連サービス業，娯楽業",
"781":"生活関連サービス業，娯楽業",
"782":"生活関連サービス業，娯楽業",
"783":"生活関連サービス業，娯楽業",
"784":"生活関連サービス業，娯楽業",
"785":"生活関連サービス業，娯楽業",
"789":"生活関連サービス業，娯楽業",
"790":"生活関連サービス業，娯楽業",
"791":"生活関連サービス業，娯楽業",
"792":"生活関連サービス業，娯楽業",
"793":"生活関連サービス業，娯楽業",
"794":"生活関連サービス業，娯楽業",
"795":"生活関連サービス業，娯楽業",
"796":"生活関連サービス業，娯楽業",
"799":"生活関連サービス業，娯楽業",
"800":"生活関連サービス業，娯楽業",
"801":"生活関連サービス業，娯楽業",
"802":"生活関連サービス業，娯楽業",
"803":"生活関連サービス業，娯楽業",
"804":"生活関連サービス業，娯楽業",
"805":"生活関連サービス業，娯楽業",
"806":"生活関連サービス業，娯楽業",
"809":"生活関連サービス業，娯楽業",
"810":"教育，学習支援業",
"811":"教育，学習支援業",
"812":"教育，学習支援業",
"813":"教育，学習支援業",
"814":"教育，学習支援業",
"815":"教育，学習支援業",
"816":"教育，学習支援業",
"817":"教育，学習支援業",
"818":"教育，学習支援業",
"819":"教育，学習支援業",
"820":"教育，学習支援業",
"821":"教育，学習支援業",
"822":"教育，学習支援業",
"823":"教育，学習支援業",
"824":"教育，学習支援業",
"829":"教育，学習支援業",
"830":"医療，福祉",
"831":"医療，福祉",
"832":"医療，福祉",
"833":"医療，福祉",
"834":"医療，福祉",
"835":"医療，福祉",
"836":"医療，福祉",
"840":"医療，福祉",
"841":"医療，福祉",
"842":"医療，福祉",
"849":"医療，福祉",
"850":"医療，福祉",
"851":"医療，福祉",
"852":"医療，福祉",
"853":"医療，福祉",
"854":"医療，福祉",
"855":"医療，福祉",
"859":"医療，福祉",
"860":"複合サービス事業",
"861":"複合サービス事業",
"862":"複合サービス事業",
"870":"複合サービス事業",
"871":"複合サービス事業",
"872":"複合サービス事業",
"880":"サービス業（他に分類されないもの）",
"881":"サービス業（他に分類されないもの）",
"882":"サービス業（他に分類されないもの）",
"889":"サービス業（他に分類されないもの）",
"890":"サービス業（他に分類されないもの）",
"891":"サービス業（他に分類されないもの）",
"900":"サービス業（他に分類されないもの）",
"901":"サービス業（他に分類されないもの）",
"902":"サービス業（他に分類されないもの）",
"903":"サービス業（他に分類されないもの）",
"909":"サービス業（他に分類されないもの）",
"910":"サービス業（他に分類されないもの）",
"911":"サービス業（他に分類されないもの）",
"912":"サービス業（他に分類されないもの）",
"920":"サービス業（他に分類されないもの）",
"921":"サービス業（他に分類されないもの）",
"922":"サービス業（他に分類されないもの）",
"923":"サービス業（他に分類されないもの）",
"929":"サービス業（他に分類されないもの）",
"931":"サービス業（他に分類されないもの）",
"932":"サービス業（他に分類されないもの）",
"933":"サービス業（他に分類されないもの）",
"934":"サービス業（他に分類されないもの）",
"939":"サービス業（他に分類されないもの）",
"941":"サービス業（他に分類されないもの）",
"942":"サービス業（他に分類されないもの）",
"943":"サービス業（他に分類されないもの）",
"949":"サービス業（他に分類されないもの）",
"950":"サービス業（他に分類されないもの）",
"951":"サービス業（他に分類されないもの）",
"952":"サービス業（他に分類されないもの）",
"959":"サービス業（他に分類されないもの）",
"961":"サービス業（他に分類されないもの）",
"969":"サービス業（他に分類されないもの）",
"971":"公務（他に分類されるものを除く）",
"972":"公務（他に分類されるものを除く）",
"973":"公務（他に分類されるものを除く）",
"981":"公務（他に分類されるものを除く）",
"982":"公務（他に分類されるものを除く）",
"999":"分類不能の産業"
}


export const Job_code_dict =
{
  "001":"管理的職業",
  "002":"管理的職業",
  "003":"管理的職業",
  "004":"研究・技術の職業",
  "005":"研究・技術の職業",
  "006":"研究・技術の職業",
  "007":"研究・技術の職業",
  "008":"研究・技術の職業",
  "009":"研究・技術の職業",
  "010":"研究・技術の職業",
  "011":"研究・技術の職業",
  "012":"法務・経営・文化芸術等の専門的職業",
  "013":"法務・経営・文化芸術等の専門的職業",
  "014":"法務・経営・文化芸術等の専門的職業",
  "015":"法務・経営・文化芸術等の専門的職業",
  "016":"法務・経営・文化芸術等の専門的職業",
  "017":"法務・経営・文化芸術等の専門的職業",
  "018":"法務・経営・文化芸術等の専門的職業",
  "019":"法務・経営・文化芸術等の専門的職業",
  "020":"法務・経営・文化芸術等の専門的職業",
  "021":"医療・看護・保健の職業",
  "022":"医療・看護・保健の職業",
  "023":"医療・看護・保健の職業",
  "024":"医療・看護・保健の職業",
  "025":"医療・看護・保健の職業",
  "026":"医療・看護・保健の職業",
  "027":"医療・看護・保健の職業",
  "028":"医療・看護・保健の職業",
  "029":"保育・教育の職業",
  "030":"保育・教育の職業",
  "031":"保育・教育の職業",
  "032":"保育・教育の職業",
  "033":"事務的職業",
  "034":"事務的職業",
  "035":"事務的職業",
  "036":"事務的職業",
  "037":"事務的職業",
  "038":"事務的職業",
  "039":"事務的職業",
  "040":"事務的職業",
  "041":"事務的職業",
  "042":"事務的職業",
  "043":"事務的職業",
  "044":"販売・営業の職業",
  "045":"販売・営業の職業",
  "046":"販売・営業の職業",
  "047":"販売・営業の職業",
  "048":"販売・営業の職業",
  "049":"福祉・介護の職業",
  "050":"福祉・介護の職業",
  "051":"福祉・介護の職業",
  "052":"サービスの職業",
  "053":"サービスの職業",
  "054":"サービスの職業",
  "055":"サービスの職業",
  "056":"サービスの職業",
  "057":"サービスの職業",
  "058":"サービスの職業",
  "059":"警備・保安の職業",
  "060":"警備・保安の職業",
  "061":"警備・保安の職業",
  "062":"警備・保安の職業",
  "063":"警備・保安の職業",
  "064":"農林漁業の職業",
  "065":"農林漁業の職業",
  "066":"農林漁業の職業",
  "067":"製造・修理・塗装・製図等の職業",
  "068":"製造・修理・塗装・製図等の職業",
  "069":"製造・修理・塗装・製図等の職業",
  "070":"製造・修理・塗装・製図等の職業",
  "071":"製造・修理・塗装・製図等の職業",
  "072":"製造・修理・塗装・製図等の職業",
  "073":"製造・修理・塗装・製図等の職業",
  "074":"製造・修理・塗装・製図等の職業",
  "075":"製造・修理・塗装・製図等の職業",
  "076":"製造・修理・塗装・製図等の職業",
  "077":"製造・修理・塗装・製図等の職業",
  "078":"製造・修理・塗装・製図等の職業",
  "079":"製造・修理・塗装・製図等の職業",
  "080":"製造・修理・塗装・製図等の職業",
  "081":"製造・修理・塗装・製図等の職業",
  "082":"配送・輸送・機械運転の職業",
  "083":"配送・輸送・機械運転の職業",
  "084":"配送・輸送・機械運転の職業",
  "085":"配送・輸送・機械運転の職業",
  "086":"配送・輸送・機械運転の職業",
  "087":"配送・輸送・機械運転の職業",
  "088":"配送・輸送・機械運転の職業",
  "089":"配送・輸送・機械運転の職業",
  "090":"建設・土木・電気工事の職業",
  "091":"建設・土木・電気工事の職業",
  "092":"建設・土木・電気工事の職業",
  "093":"建設・土木・電気工事の職業",
  "094":"建設・土木・電気工事の職業",
  "095":"運搬・清掃・包装・選別等の職業",
  "096":"運搬・清掃・包装・選別等の職業",
  "097":"運搬・清掃・包装・選別等の職業",
  "098":"運搬・清掃・包装・選別等の職業",
  "099":"運搬・清掃・包装・選別等の職業",
  "001-01":"管理的職業",
  "001-99":"管理的職業",
  "002-01":"管理的職業",
  "002-99":"管理的職業",
  "003-01":"管理的職業",
  "003-99":"管理的職業",
  "004-01":"研究・技術の職業",
  "004-02":"研究・技術の職業",
  "004-95":"研究・技術の職業",
  "005-01":"研究・技術の職業",
  "006-01":"研究・技術の職業",
  "006-02":"研究・技術の職業",
  "006-03":"研究・技術の職業",
  "006-04":"研究・技術の職業",
  "006-05":"研究・技術の職業",
  "006-06":"研究・技術の職業",
  "006-07":"研究・技術の職業",
  "006-99":"研究・技術の職業",
  "007-01":"研究・技術の職業",
  "007-02":"研究・技術の職業",
  "007-03":"研究・技術の職業",
  "007-04":"研究・技術の職業",
  "007-05":"研究・技術の職業",
  "007-06":"研究・技術の職業",
  "007-07":"研究・技術の職業",
  "007-08":"研究・技術の職業",
  "007-95":"研究・技術の職業",
  "007-99":"研究・技術の職業",
  "008-01":"研究・技術の職業",
  "008-02":"研究・技術の職業",
  "008-03":"研究・技術の職業",
  "008-04":"研究・技術の職業",
  "008-05":"研究・技術の職業",
  "008-06":"研究・技術の職業",
  "008-07":"研究・技術の職業",
  "008-95":"研究・技術の職業",
  "009-01":"研究・技術の職業",
  "009-02":"研究・技術の職業",
  "009-03":"研究・技術の職業",
  "009-95":"研究・技術の職業",
  "009-99":"研究・技術の職業",
  "010-01":"研究・技術の職業",
  "010-02":"研究・技術の職業",
  "010-03":"研究・技術の職業",
  "010-04":"研究・技術の職業",
  "010-05":"研究・技術の職業",
  "010-06":"研究・技術の職業",
  "010-95":"研究・技術の職業",
  "010-99":"研究・技術の職業",
  "011-01":"研究・技術の職業",
  "011-99":"研究・技術の職業",
  "012-01":"法務・経営・文化芸術等の専門的職業",
  "012-02":"法務・経営・文化芸術等の専門的職業",
  "012-03":"法務・経営・文化芸術等の専門的職業",
  "012-99":"法務・経営・文化芸術等の専門的職業",
  "013-01":"法務・経営・文化芸術等の専門的職業",
  "013-02":"法務・経営・文化芸術等の専門的職業",
  "013-03":"法務・経営・文化芸術等の専門的職業",
  "013-99":"法務・経営・文化芸術等の専門的職業",
  "014-01":"法務・経営・文化芸術等の専門的職業",
  "015-01":"法務・経営・文化芸術等の専門的職業",
  "015-02":"法務・経営・文化芸術等の専門的職業",
  "015-03":"法務・経営・文化芸術等の専門的職業",
  "015-95":"法務・経営・文化芸術等の専門的職業",
  "016-01":"法務・経営・文化芸術等の専門的職業",
  "016-02":"法務・経営・文化芸術等の専門的職業",
  "016-95":"法務・経営・文化芸術等の専門的職業",
  "017-01":"法務・経営・文化芸術等の専門的職業",
  "017-02":"法務・経営・文化芸術等の専門的職業",
  "017-95":"法務・経営・文化芸術等の専門的職業",
  "017-99":"法務・経営・文化芸術等の専門的職業",
  "018-01":"法務・経営・文化芸術等の専門的職業",
  "018-02":"法務・経営・文化芸術等の専門的職業",
  "018-03":"法務・経営・文化芸術等の専門的職業",
  "018-95":"法務・経営・文化芸術等の専門的職業",
  "019-01":"法務・経営・文化芸術等の専門的職業",
  "019-02":"法務・経営・文化芸術等の専門的職業",
  "019-03":"法務・経営・文化芸術等の専門的職業",
  "019-95":"法務・経営・文化芸術等の専門的職業",
  "020-01":"法務・経営・文化芸術等の専門的職業",
  "020-02":"法務・経営・文化芸術等の専門的職業",
  "020-95":"法務・経営・文化芸術等の専門的職業",
  "020-99":"法務・経営・文化芸術等の専門的職業",
  "021-01":"医療・看護・保健の職業",
  "021-02":"医療・看護・保健の職業",
  "021-03":"医療・看護・保健の職業",
  "021-04":"医療・看護・保健の職業",
  "022-01":"医療・看護・保健の職業",
  "022-02":"医療・看護・保健の職業",
  "023-01":"医療・看護・保健の職業",
  "023-02":"医療・看護・保健の職業",
  "023-03":"医療・看護・保健の職業",
  "023-95":"医療・看護・保健の職業",
  "023-99":"医療・看護・保健の職業",
  "024-01":"医療・看護・保健の職業",
  "024-02":"医療・看護・保健の職業",
  "024-03":"医療・看護・保健の職業",
  "024-04":"医療・看護・保健の職業",
  "024-05":"医療・看護・保健の職業",
  "024-06":"医療・看護・保健の職業",
  "024-07":"医療・看護・保健の職業",
  "024-08":"医療・看護・保健の職業",
  "024-09":"医療・看護・保健の職業",
  "024-95":"医療・看護・保健の職業",
  "025-01":"医療・看護・保健の職業",
  "025-02":"医療・看護・保健の職業",
  "025-95":"医療・看護・保健の職業",
  "026-01":"医療・看護・保健の職業",
  "026-02":"医療・看護・保健の職業",
  "027-95":"医療・看護・保健の職業",
  "027-99":"医療・看護・保健の職業",
  "028-01":"医療・看護・保健の職業",
  "028-02":"医療・看護・保健の職業",
  "028-99":"医療・看護・保健の職業",
  "029-01":"保育・教育の職業",
  "029-02":"保育・教育の職業",
  "029-03":"保育・教育の職業",
  "030-01":"保育・教育の職業",
  "030-02":"保育・教育の職業",
  "030-03":"保育・教育の職業",
  "030-95":"保育・教育の職業",
  "031-01":"保育・教育の職業",
  "031-02":"保育・教育の職業",
  "031-03":"保育・教育の職業",
  "031-04":"保育・教育の職業",
  "031-05":"保育・教育の職業",
  "031-06":"保育・教育の職業",
  "031-07":"保育・教育の職業",
  "031-95":"保育・教育の職業",
  "031-99":"保育・教育の職業",
  "032-01":"保育・教育の職業",
  "032-02":"保育・教育の職業",
  "032-03":"保育・教育の職業",
  "032-95":"保育・教育の職業",
  "033-01":"事務的職業",
  "033-02":"事務的職業",
  "033-03":"事務的職業",
  "033-95":"事務的職業",
  "034-01":"事務的職業",
  "034-02":"事務的職業",
  "034-03":"事務的職業",
  "034-95":"事務的職業",
  "035-01":"事務的職業",
  "035-95":"事務的職業",
  "035-99":"事務的職業",
  "036-01":"事務的職業",
  "036-02":"事務的職業",
  "036-03":"事務的職業",
  "036-04":"事務的職業",
  "036-95":"事務的職業",
  "037-01":"事務的職業",
  "037-02":"事務的職業",
  "037-03":"事務的職業",
  "037-95":"事務的職業",
  "038-01":"事務的職業",
  "038-02":"事務的職業",
  "038-03":"事務的職業",
  "038-99":"事務的職業",
  "039-01":"事務的職業",
  "039-02":"事務的職業",
  "039-95":"事務的職業",
  "040-01":"事務的職業",
  "040-02":"事務的職業",
  "040-95":"事務的職業",
  "040-99":"事務的職業",
  "041-01":"事務的職業",
  "041-02":"事務的職業",
  "041-99":"事務的職業",
  "042-01":"事務的職業",
  "042-02":"事務的職業",
  "042-03":"事務的職業",
  "043-01":"事務的職業",
  "043-02":"事務的職業",
  "043-99":"事務的職業",
  "044-01":"販売・営業の職業",
  "044-02":"販売・営業の職業",
  "045-01":"販売・営業の職業",
  "045-02":"販売・営業の職業",
  "045-03":"販売・営業の職業",
  "045-04":"販売・営業の職業",
  "045-05":"販売・営業の職業",
  "045-06":"販売・営業の職業",
  "045-07":"販売・営業の職業",
  "045-08":"販売・営業の職業",
  "045-09":"販売・営業の職業",
  "045-10":"販売・営業の職業",
  "045-11":"販売・営業の職業",
  "045-12":"販売・営業の職業",
  "045-13":"販売・営業の職業",
  "045-14":"販売・営業の職業",
  "045-15":"販売・営業の職業",
  "045-16":"販売・営業の職業",
  "045-95":"販売・営業の職業",
  "046-01":"販売・営業の職業",
  "046-02":"販売・営業の職業",
  "047-01":"販売・営業の職業",
  "047-02":"販売・営業の職業",
  "047-03":"販売・営業の職業",
  "047-99":"販売・営業の職業",
  "048-01":"販売・営業の職業",
  "048-02":"販売・営業の職業",
  "048-03":"販売・営業の職業",
  "048-04":"販売・営業の職業",
  "048-05":"販売・営業の職業",
  "048-06":"販売・営業の職業",
  "048-07":"販売・営業の職業",
  "048-08":"販売・営業の職業",
  "048-09":"販売・営業の職業",
  "048-10":"販売・営業の職業",
  "048-11":"販売・営業の職業",
  "048-95":"販売・営業の職業",
  "048-99":"販売・営業の職業",
  "049-01":"福祉・介護の職業",
  "049-02":"福祉・介護の職業",
  "049-03":"福祉・介護の職業",
  "049-04":"福祉・介護の職業",
  "049-05":"福祉・介護の職業",
  "049-06":"福祉・介護の職業",
  "049-07":"福祉・介護の職業",
  "049-08":"福祉・介護の職業",
  "049-09":"福祉・介護の職業",
  "049-10":"福祉・介護の職業",
  "049-95":"福祉・介護の職業",
  "049-99":"福祉・介護の職業",
  "050-01":"福祉・介護の職業",
  "050-02":"福祉・介護の職業",
  "050-03":"福祉・介護の職業",
  "050-95":"福祉・介護の職業",
  "050-99":"福祉・介護の職業",
  "051-01":"福祉・介護の職業",
  "051-02":"福祉・介護の職業",
  "051-95":"福祉・介護の職業",
  "052-01":"サービスの職業",
  "052-99":"サービスの職業",
  "053-01":"サービスの職業",
  "053-02":"サービスの職業",
  "053-03":"サービスの職業",
  "053-04":"サービスの職業",
  "053-05":"サービスの職業",
  "053-95":"サービスの職業",
  "053-99":"サービスの職業",
  "054-01":"サービスの職業",
  "054-02":"サービスの職業",
  "055-01":"サービスの職業",
  "055-02":"サービスの職業",
  "055-03":"サービスの職業",
  "055-04":"サービスの職業",
  "055-05":"サービスの職業",
  "055-06":"サービスの職業",
  "055-07":"サービスの職業",
  "055-08":"サービスの職業",
  "055-09":"サービスの職業",
  "055-95":"サービスの職業",
  "055-99":"サービスの職業",
  "056-01":"サービスの職業",
  "056-02":"サービスの職業",
  "056-03":"サービスの職業",
  "056-04":"サービスの職業",
  "056-05":"サービスの職業",
  "056-06":"サービスの職業",
  "056-07":"サービスの職業",
  "056-08":"サービスの職業",
  "056-95":"サービスの職業",
  "056-99":"サービスの職業",
  "057-01":"サービスの職業",
  "057-02":"サービスの職業",
  "057-03":"サービスの職業",
  "057-04":"サービスの職業",
  "057-99":"サービスの職業",
  "058-01":"サービスの職業",
  "058-02":"サービスの職業",
  "058-03":"サービスの職業",
  "058-04":"サービスの職業",
  "058-05":"サービスの職業",
  "058-06":"サービスの職業",
  "058-07":"サービスの職業",
  "058-08":"サービスの職業",
  "058-95":"サービスの職業",
  "058-99":"サービスの職業",
  "059-01":"警備・保安の職業",
  "059-02":"警備・保安の職業",
  "059-95":"警備・保安の職業",
  "059-99":"警備・保安の職業",
  "060-01":"警備・保安の職業",
  "061-01":"警備・保安の職業",
  "061-99":"警備・保安の職業",
  "062-01":"警備・保安の職業",
  "062-02":"警備・保安の職業",
  "063-95":"警備・保安の職業",
  "063-99":"警備・保安の職業",
  "064-01":"農林漁業の職業",
  "064-02":"農林漁業の職業",
  "064-03":"農林漁業の職業",
  "064-04":"農林漁業の職業",
  "064-05":"農林漁業の職業",
  "064-95":"農林漁業の職業",
  "064-99":"農林漁業の職業",
  "065-01":"農林漁業の職業",
  "065-02":"農林漁業の職業",
  "065-99":"農林漁業の職業",
  "066-01":"農林漁業の職業",
  "066-02":"農林漁業の職業",
  "066-03":"農林漁業の職業",
  "066-04":"農林漁業の職業",
  "066-99":"農林漁業の職業",
  "067-01":"製造・修理・塗装・製図等の職業",
  "067-02":"製造・修理・塗装・製図等の職業",
  "067-03":"製造・修理・塗装・製図等の職業",
  "067-04":"製造・修理・塗装・製図等の職業",
  "067-05":"製造・修理・塗装・製図等の職業",
  "067-06":"製造・修理・塗装・製図等の職業",
  "067-07":"製造・修理・塗装・製図等の職業",
  "067-08":"製造・修理・塗装・製図等の職業",
  "067-99":"製造・修理・塗装・製図等の職業",
  "068-01":"製造・修理・塗装・製図等の職業",
  "068-02":"製造・修理・塗装・製図等の職業",
  "069-01":"製造・修理・塗装・製図等の職業",
  "069-02":"製造・修理・塗装・製図等の職業",
  "069-03":"製造・修理・塗装・製図等の職業",
  "069-04":"製造・修理・塗装・製図等の職業",
  "069-05":"製造・修理・塗装・製図等の職業",
  "069-06":"製造・修理・塗装・製図等の職業",
  "069-95":"製造・修理・塗装・製図等の職業",
  "069-99":"製造・修理・塗装・製図等の職業",
  "070-01":"製造・修理・塗装・製図等の職業",
  "070-02":"製造・修理・塗装・製図等の職業",
  "070-03":"製造・修理・塗装・製図等の職業",
  "070-04":"製造・修理・塗装・製図等の職業",
  "070-05":"製造・修理・塗装・製図等の職業",
  "071-01":"製造・修理・塗装・製図等の職業",
  "071-02":"製造・修理・塗装・製図等の職業",
  "071-03":"製造・修理・塗装・製図等の職業",
  "071-04":"製造・修理・塗装・製図等の職業",
  "071-05":"製造・修理・塗装・製図等の職業",
  "071-06":"製造・修理・塗装・製図等の職業",
  "071-07":"製造・修理・塗装・製図等の職業",
  "071-08":"製造・修理・塗装・製図等の職業",
  "071-09":"製造・修理・塗装・製図等の職業",
  "071-10":"製造・修理・塗装・製図等の職業",
  "071-11":"製造・修理・塗装・製図等の職業",
  "071-12":"製造・修理・塗装・製図等の職業",
  "071-13":"製造・修理・塗装・製図等の職業",
  "071-95":"製造・修理・塗装・製図等の職業",
  "072-01":"製造・修理・塗装・製図等の職業",
  "072-02":"製造・修理・塗装・製図等の職業",
  "072-03":"製造・修理・塗装・製図等の職業",
  "072-04":"製造・修理・塗装・製図等の職業",
  "072-05":"製造・修理・塗装・製図等の職業",
  "072-06":"製造・修理・塗装・製図等の職業",
  "072-07":"製造・修理・塗装・製図等の職業",
  "071-99":"製造・修理・塗装・製図等の職業",
  "073-01":"製造・修理・塗装・製図等の職業",
  "073-02":"製造・修理・塗装・製図等の職業",
  "073-03":"製造・修理・塗装・製図等の職業",
  "073-04":"製造・修理・塗装・製図等の職業",
  "073-05":"製造・修理・塗装・製図等の職業",
  "073-06":"製造・修理・塗装・製図等の職業",
  "073-07":"製造・修理・塗装・製図等の職業",
  "073-08":"製造・修理・塗装・製図等の職業",
  "073-95":"製造・修理・塗装・製図等の職業",
  "073-99":"製造・修理・塗装・製図等の職業",
  "074-01":"製造・修理・塗装・製図等の職業",
  "074-02":"製造・修理・塗装・製図等の職業",
  "074-03":"製造・修理・塗装・製図等の職業",
  "074-04":"製造・修理・塗装・製図等の職業",
  "074-05":"製造・修理・塗装・製図等の職業",
  "074-06":"製造・修理・塗装・製図等の職業",
  "074-07":"製造・修理・塗装・製図等の職業",
  "074-08":"製造・修理・塗装・製図等の職業",
  "074-09":"製造・修理・塗装・製図等の職業",
  "074-10":"製造・修理・塗装・製図等の職業",
  "074-11":"製造・修理・塗装・製図等の職業",
  "074-12":"製造・修理・塗装・製図等の職業",
  "074-13":"製造・修理・塗装・製図等の職業",
  "075-01":"製造・修理・塗装・製図等の職業",
  "075-02":"製造・修理・塗装・製図等の職業",
  "075-03":"製造・修理・塗装・製図等の職業",
  "075-04":"製造・修理・塗装・製図等の職業",
  "075-05":"製造・修理・塗装・製図等の職業",
  "076-01":"製造・修理・塗装・製図等の職業",
  "076-02":"製造・修理・塗装・製図等の職業",
  "077-01":"製造・修理・塗装・製図等の職業",
  "077-02":"製造・修理・塗装・製図等の職業",
  "078-01":"製造・修理・塗装・製図等の職業",
  "078-02":"製造・修理・塗装・製図等の職業",
  "078-03":"製造・修理・塗装・製図等の職業",
  "078-04":"製造・修理・塗装・製図等の職業",
  "078-05":"製造・修理・塗装・製図等の職業",
  "078-06":"製造・修理・塗装・製図等の職業",
  "078-95":"製造・修理・塗装・製図等の職業",
  "078-99":"製造・修理・塗装・製図等の職業",
  "079-01":"製造・修理・塗装・製図等の職業",
  "079-02":"製造・修理・塗装・製図等の職業",
  "079-03":"製造・修理・塗装・製図等の職業",
  "079-04":"製造・修理・塗装・製図等の職業",
  "079-05":"製造・修理・塗装・製図等の職業",
  "080-01":"製造・修理・塗装・製図等の職業",
  "080-02":"製造・修理・塗装・製図等の職業",
  "080-03":"製造・修理・塗装・製図等の職業",
  "080-04":"製造・修理・塗装・製図等の職業",
  "080-05":"製造・修理・塗装・製図等の職業",
  "080-06":"製造・修理・塗装・製図等の職業",
  "080-95":"製造・修理・塗装・製図等の職業",
  "080-99":"製造・修理・塗装・製図等の職業",
  "081-01":"製造・修理・塗装・製図等の職業",
  "082-01":"配送・輸送・機械運転の職業",
  "082-02":"配送・輸送・機械運転の職業",
  "082-03":"配送・輸送・機械運転の職業",
  "082-04":"配送・輸送・機械運転の職業",
  "082-95":"配送・輸送・機械運転の職業",
  "083-01":"配送・輸送・機械運転の職業",
  "083-02":"配送・輸送・機械運転の職業",
  "083-03":"配送・輸送・機械運転の職業",
  "083-04":"配送・輸送・機械運転の職業",
  "083-95":"配送・輸送・機械運転の職業",
  "083-99":"配送・輸送・機械運転の職業",
  "084-01":"配送・輸送・機械運転の職業",
  "084-02":"配送・輸送・機械運転の職業",
  "084-95":"配送・輸送・機械運転の職業",
  "085-01":"配送・輸送・機械運転の職業",
  "085-02":"配送・輸送・機械運転の職業",
  "085-03":"配送・輸送・機械運転の職業",
  "085-04":"配送・輸送・機械運転の職業",
  "085-95":"配送・輸送・機械運転の職業",
  "085-99":"配送・輸送・機械運転の職業",
  "086-95":"配送・輸送・機械運転の職業",
  "086-99":"配送・輸送・機械運転の職業",
  "087-01":"配送・輸送・機械運転の職業",
  "087-02":"配送・輸送・機械運転の職業",
  "087-03":"配送・輸送・機械運転の職業",
  "087-04":"配送・輸送・機械運転の職業",
  "088-01":"配送・輸送・機械運転の職業",
  "088-02":"配送・輸送・機械運転の職業",
  "088-03":"配送・輸送・機械運転の職業",
  "088-04":"配送・輸送・機械運転の職業",
  "088-99":"配送・輸送・機械運転の職業",
  "089-01":"配送・輸送・機械運転の職業",
  "089-02":"配送・輸送・機械運転の職業",
  "089-03":"配送・輸送・機械運転の職業",
  "089-04":"配送・輸送・機械運転の職業",
  "089-05":"配送・輸送・機械運転の職業",
  "089-99":"配送・輸送・機械運転の職業",
  "090-01":"建設・土木・電気工事の職業",
  "090-02":"建設・土木・電気工事の職業",
  "090-03":"建設・土木・電気工事の職業",
  "090-04":"建設・土木・電気工事の職業",
  "090-95":"建設・土木・電気工事の職業",
  "091-01":"建設・土木・電気工事の職業",
  "091-02":"建設・土木・電気工事の職業",
  "091-03":"建設・土木・電気工事の職業",
  "091-04":"建設・土木・電気工事の職業",
  "091-05":"建設・土木・電気工事の職業",
  "091-06":"建設・土木・電気工事の職業",
  "091-07":"建設・土木・電気工事の職業",
  "091-08":"建設・土木・電気工事の職業",
  "091-99":"建設・土木・電気工事の職業",
  "092-01":"建設・土木・電気工事の職業",
  "092-02":"建設・土木・電気工事の職業",
  "092-03":"建設・土木・電気工事の職業",
  "092-04":"建設・土木・電気工事の職業",
  "092-95":"建設・土木・電気工事の職業",
  "093-01":"建設・土木・電気工事の職業",
  "093-99":"建設・土木・電気工事の職業",
  "094-01":"建設・土木・電気工事の職業",
  "094-02":"建設・土木・電気工事の職業",
  "094-03":"建設・土木・電気工事の職業",
  "094-04":"建設・土木・電気工事の職業",
  "094-05":"建設・土木・電気工事の職業",
  "095-01":"運搬・清掃・包装・選別等の職業",
  "095-02":"運搬・清掃・包装・選別等の職業",
  "095-03":"運搬・清掃・包装・選別等の職業",
  "095-04":"運搬・清掃・包装・選別等の職業",
  "095-95":"運搬・清掃・包装・選別等の職業",
  "096-01":"運搬・清掃・包装・選別等の職業",
  "096-02":"運搬・清掃・包装・選別等の職業",
  "096-03":"運搬・清掃・包装・選別等の職業",
  "096-04":"運搬・清掃・包装・選別等の職業",
  "096-05":"運搬・清掃・包装・選別等の職業",
  "096-06":"運搬・清掃・包装・選別等の職業",
  "096-07":"運搬・清掃・包装・選別等の職業",
  "096-95":"運搬・清掃・包装・選別等の職業",
  "096-99":"運搬・清掃・包装・選別等の職業",
  "097-01":"運搬・清掃・包装・選別等の職業",
  "097-02":"運搬・清掃・包装・選別等の職業",
  "098-01":"運搬・清掃・包装・選別等の職業",
  "098-02":"運搬・清掃・包装・選別等の職業",
  "098-95":"運搬・清掃・包装・選別等の職業",
  "099-01":"運搬・清掃・包装・選別等の職業",
  "099-02":"運搬・清掃・包装・選別等の職業",
  "099-03":"運搬・清掃・包装・選別等の職業",
  "099-04":"運搬・清掃・包装・選別等の職業",
  "099-95":"運搬・清掃・包装・選別等の職業",
  "099-99":"運搬・清掃・包装・選別等の職業",
}